import { NgModule } from '@angular/core';
import { FuseSharedModule } from '@fuse/shared.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { SharedModule } from '@shared/shared.module';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { DirectivesModule } from '@shared/directives/directives.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { OrderModule } from 'ngx-order-pipe';
import { PremiumFormWidgetElectricMeterComponent } from './premium-form-widget-electric-meter.component';
import { HasBerthValidator } from '@shared/validators/boat/async/has-berth.validator';
import { DateFnsModule } from 'ngx-date-fns';
import { NumberInputModule } from '@shared/components/form/number-input/number-input.module';

@NgModule({
    declarations: [PremiumFormWidgetElectricMeterComponent],
    imports: [

        FuseSharedModule,
        SharedModule,

        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatButtonModule,
        MatSelectModule,
        MatDatepickerModule,
        MatAutocompleteModule,
        DirectivesModule,
        MatCheckboxModule,
        MatProgressSpinnerModule,
        OrderModule,
        DateFnsModule,
        NumberInputModule,
    ],
    providers: [HasBerthValidator],
    exports: [PremiumFormWidgetElectricMeterComponent]
})
export class PremiumFormWidgetElectricMeterModule {

}
